export const scrollTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const scrollDisable = (selector) => {
  if (selector) {
    selector.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'hidden';
  }
};

export const scrollEnable = (selector) => {
  if (selector) {
    selector.style.overflow = 'auto';
  } else {
    document.body.style.overflow = 'auto';
  }
};
